// ALBA Flow Rules — Product catalog, RAL restrictions, min quantities

export const ALBA_SUB_CATEGORIES = [
  {
    id: 'magic',
    name: 'ALBA MAGIC',
    description: 'Punto di fissaggio con sistema smorzante brevettato',
    glass: '12+12 SG',
    rodIncluded: true,
    holeDiameter: 36,
    regulation: '50-65 mm',
  },
  {
    id: 'circle',
    name: 'ALBA CIRCLE',
    description: 'Punto di fissaggio tondo in acciaio inox AISI 316',
    glass: '10+10 PVB',
    rodIncluded: false,
    holeDiameter: 26,
  },
  {
    id: 'square',
    name: 'ALBA SQUARE',
    description: 'Punto di fissaggio quadrato in acciaio inox AISI 316',
    glass: '10+10 PVB',
    rodIncluded: false,
    holeDiameter: 26,
  },
  {
    id: 'mini',
    name: 'ALBA MINI',
    description: 'Soluzione compatta in acciaio inox AISI 316',
    glass: '10+10 PVB',
    rodIncluded: true,
    holeDiameter: 22,
    regulation: '34-44 mm',
  },
  {
    id: 'accessori',
    name: 'ACCESSORI',
    description: 'Accessori per Alba Circle e Square',
  },
];

export const ALBA_PRODUCTS = {
  magic: {
    standard: [
      { code: 'R09-M-B', finish: 'Bianco RAL 9016 opaco', price: 68.00, minQty: 0 },
      { code: 'R09-M-G', finish: 'Antracite RAL 7016 opaco', price: 68.00, minQty: 0 },
      { code: 'R09-M-K', finish: 'Simil Corten NKR3', price: 70.00, minQty: 0 },
      { code: 'R09-M-O', finish: 'Pearl Gold RAL 1036', price: 70.00, minQty: 0 },
    ],
    custom: [
      { code: 'R09-M-SPE1', finish: 'RAL personalizzato (20-50 pz)', price: 77.00, minQty: 20, maxQty: 50, needsRal: true },
      { code: 'R09-M-SPE2', finish: 'RAL personalizzato (51-200 pz)', price: 75.00, minQty: 51, maxQty: 200, needsRal: true },
      { code: 'R09-M-SPE3', finish: 'RAL personalizzato (oltre 200 pz)', price: 73.00, minQty: 201, maxQty: Infinity, needsRal: true },
    ],
  },

  circle: {
    standard: [
      { code: 'R09-B', finish: 'Inox Lucido (reg. 35-50mm)', price: 59.00, minQty: 0, regulation: '35-50' },
      { code: 'R09-B-ST', finish: 'Inox Satinato (reg. 35-50mm)', price: 59.00, minQty: 0, regulation: '35-50' },
      { code: 'R09-C', finish: 'Inox Lucido (reg. 51-65mm)', price: 66.00, minQty: 0, regulation: '51-65' },
      { code: 'R09-C-ST', finish: 'Inox Satinato (reg. 51-65mm)', price: 66.00, minQty: 0, regulation: '51-65' },
    ],
    trend: [
      { code: 'R09-B-VS', finish: 'RAL Trend (reg. 35-50mm)', price: 71.00, minQty: 20, needsRal: true, ralRestriction: 'trend' },
      { code: 'R09-C-VS', finish: 'RAL Trend (reg. 51-65mm)', price: 80.00, minQty: 20, needsRal: true, ralRestriction: 'trend' },
    ],
    custom: [
      { code: 'R09-B-V', finish: 'RAL Personalizzato (reg. 35-50mm)', price: 74.00, minQty: 20, needsRal: true, ralRestriction: 'custom' },
      { code: 'R09-C-V', finish: 'RAL Personalizzato (reg. 51-65mm)', price: 84.00, minQty: 20, needsRal: true, ralRestriction: 'custom' },
    ],
  },

  square: {
    standard: [
      { code: 'R09-D', finish: 'Inox Lucido (reg. 35-50mm)', price: 79.00, minQty: 0, regulation: '35-50' },
      { code: 'R09-D-ST', finish: 'Inox Satinato (reg. 35-50mm)', price: 79.00, minQty: 0, regulation: '35-50' },
      { code: 'R09-E', finish: 'Inox Lucido (reg. 51-65mm)', price: 85.00, minQty: 0, regulation: '51-65' },
      { code: 'R09-E-ST', finish: 'Inox Satinato (reg. 51-65mm)', price: 85.00, minQty: 0, regulation: '51-65' },
    ],
    trend: [
      { code: 'R09-D-VS', finish: 'RAL Trend (reg. 35-50mm)', price: 91.00, minQty: 20, needsRal: true, ralRestriction: 'trend' },
      { code: 'R09-E-VS', finish: 'RAL Trend (reg. 51-65mm)', price: 95.00, minQty: 20, needsRal: true, ralRestriction: 'trend' },
    ],
    custom: [
      { code: 'R09-D-V', finish: 'RAL Personalizzato (reg. 35-50mm)', price: 93.00, minQty: 20, needsRal: true, ralRestriction: 'custom' },
      { code: 'R09-E-V', finish: 'RAL Personalizzato (reg. 51-65mm)', price: 96.00, minQty: 20, needsRal: true, ralRestriction: 'custom' },
    ],
  },

  mini: {
    standard: [
      { code: 'R09-A-316L', finish: 'Inox Lucido', price: 36.00, minQty: 0 },
      { code: 'R09-A-316S', finish: 'Inox Satinato', price: 36.00, minQty: 0 },
    ],
  },

  accessori: {
    items: [
      { code: 'R09B-A004', description: 'Rondella distanziatrice in plastica nera', price: 3.60, validFor: ['circle'] },
      { code: 'R09D-A005', description: 'Guarnizione di spessore nera', price: 2.90, validFor: ['square'] },
      { code: 'M13-AC-08', description: 'Astina zincata M12x140 con dado e rondella', price: 4.00, validFor: ['circle', 'square'] },
    ],
  },
};

// RAL codes forbidden for Magic custom paint
const MAGIC_FORBIDDEN_RALS = ['9016', '7016', '1036'];
const MAGIC_FORBIDDEN_NAMES = ['NKR3'];

// Trend RAL: only these allowed for -VS codes
const TREND_ALLOWED_RALS = ['9016', '9005'];

export function validateRal(ralCode, restriction, subCategory) {
  if (!ralCode || ralCode.trim() === '') return 'Inserisci un codice RAL';
  const code = ralCode.trim();
  if (!/^\d{4}$/.test(code)) return 'Il codice RAL deve essere di 4 cifre';

  if (subCategory === 'magic') {
    if (MAGIC_FORBIDDEN_RALS.includes(code) || MAGIC_FORBIDDEN_NAMES.includes(code)) {
      return 'Questo RAL è già disponibile come colore standard. Scegli un RAL diverso.';
    }
  }

  if (restriction === 'trend') {
    if (!TREND_ALLOWED_RALS.includes(code)) {
      return 'Per i colori Trend sono ammessi solo RAL 9016 e RAL 9005';
    }
  }

  if (restriction === 'custom') {
    if (TREND_ALLOWED_RALS.includes(code)) {
      return 'RAL 9016 e 9005 sono disponibili come colori Trend. Usa il codice -VS oppure scegli un RAL diverso.';
    }
  }

  return null;
}

export function getAutoTierCode(quantity, subCategory) {
  if (subCategory !== 'magic') return null;
  const qty = parseInt(quantity, 10);
  if (isNaN(qty) || qty < 20) return null;
  if (qty <= 50) return 'R09-M-SPE1';
  if (qty <= 200) return 'R09-M-SPE2';
  return 'R09-M-SPE3';
}

export function getAutoTierPrice(quantity) {
  const qty = parseInt(quantity, 10);
  if (isNaN(qty) || qty < 20) return null;
  if (qty <= 50) return 77.00;
  if (qty <= 200) return 75.00;
  return 73.00;
}

export function getAllProductsFlat(subCategory) {
  const cat = ALBA_PRODUCTS[subCategory];
  if (!cat) return [];
  if (subCategory === 'accessori') return cat.items || [];
  return [...(cat.standard || []), ...(cat.trend || []), ...(cat.custom || [])];
}
